<template>
    <section class="notes">
        <b-button v-if="parent" variant='outline-primary' @click="copyFromParent" class="mb-3" size="sm">
            Copy notes from parent
        </b-button>
        <draggable :list="notes" :options="{draggable:'.card'}" @start="handleDragStart" @end="handleDragEnd">
            <note v-for="(note, index) in notes" :note="note" :key="note.key" @remove="remove(index)" @move:up="moveUp(index)" @move:down="moveDown(index)" :readonly="readonly" class="mb-3"/>
            <b-button-group slot="footer" v-if="!readonly">
                <b-button variant="muted"
                          size="sm"
                          @click.prevent="addNewNote('note')">Add Note
                </b-button>
                <b-button variant="muted"
                          size="sm"
                          @click.prevent="addNewNote('scripture')">Add Scripture
                </b-button>
                <b-button variant="muted"
                          size="sm"
                          @click.prevent="addNewNote('image')">Add Image
                </b-button>
            </b-button-group>
        </draggable>
    </section>
</template>

<script>

    import Note from './Note'
    import Draggable from 'vuedraggable'
    import move from "array-move"

    export default {
        components: {Draggable, Note},
        props: {
            readonly: {
                default: false
            },
            notes: {
                type: Array,
                default()
                {
                    return []
                }
            },
            parent: {}
        },
        methods: {
            addNewNote(type)
            {
                this.notes.push({type})
            },
            remove(index)
            {
                this.notes.splice(index, 1)
            },
            clear() {
                this.notes.splice(0,this.notes.length)
            },
            validate()
            {
                let result = true
                if (this.$refs.notes) {
                    this.$refs.notes.forEach(note => (result = note.validate()))
                }
                return result
            },
            handleDragStart() {
                events.$emit('note:drag:start')
            },
            handleDragEnd() {
                events.$emit('note:drag:end')
            },
            copyFromParent() {
                let really = confirm("Are you sure? This will replace the notes you've already added.");
                if (!really) {
                    return;
                }

                this.clear()

                //Let the note component rekey the message notes to avoid conflicts.
                this.parent.notes.forEach((note) => {
                    delete note['key']
                    this.notes.push(note)
                })
            }
        }
    }
</script>
